module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				fieldIsRequired: fox.i18n.getTranslation('fieldIsRequired', 'This field is required', 'errors'),
				errorAgreeOperatorAgreement: fox.i18n.getTranslation('errorAgreeOperatorAgreement', 'You must agree to the Website Operator Agreement', 'errors'),
				enterValidEmail: fox.i18n.getTranslation('enterValidEmail', 'Please enter a valid email address', 'errors')
			};
			
			return translation[alias] || '';
		}
	};

	var EXO_UDID = require('../../../../../common-components/verification-form/exo-udid')(fox);

	fox.registerWidget('Promo_Registration', {

		configure: function () {
			this.fields = null;
			this.data = {};
			this.dataFromDB = {
				email: false,
				domain: false,
			};
			this.fieldsNames = {
				firstName: 'First name',
				lastName: 'Last Name',
				screen: 'Screen name',
				email: 'Email'
			};

			this.registerOptions('', {
				autoRender: true,

				'widgets.checkEmailApi': {
					widget: 'Api',
					method: 'registration.checkEmail'
				},

				'widgets.errorPopup': {
					widget: 'PopupWidget',
					title: 'Error',
					dialog: {
						width: '590px',
						dialogClass: 'dlg-amc dark-overlay dlg-amc-error',
					},
					'widgets.content': {
						widget: 'Widget',
						autoRender: true,
						template: 'popup_promo_registration_error'
					}
				},

				'widgets.registerApi': {
					widget: 'Api',
					method: 'registration.register',
					httpMethod: 'post',
					encodePost: true
				},
				'widgets.recaptcha': {
					widget: 'RecaptchaFox'
				},
				'widgets.snManager': {
					widget: 'SocialNetwork_Manager',
					mode: 'signup',
					container: '.soc-buttons',
					template: 'promo_social_buttons',
					autoRender: false,
					'handleDom.openNetworkWindow': {
						target: '.soc-button',
						event: 'click',
						callback: 'socialClickHandler'
					}
				},
				handleWom:{
					registerFailed: {
						widget: '#registerApi',
						event: 'failure',
						callback: 'showErrorPopup'
					},
					registerError: {
						widget: '#registerApi',
						event: ['error', 'failure'],
						callback: 'showRecaptchaOnError'
					},
					registerSuccess: {
						widget: '#registerApi',
						event: 'success',
						callback: 'signIn'
					},
					showPreloader: {
						widget: '#registerApi',
						event: ['error', 'failure'],
						callback: 'togglePreloader'
					},
					socialsNetworksListLoaded: {
						widget: '#snManager',
						event: 'updated',
						callback: 'renderNetworksTemplate'
					},
					handleRecievedProfile: {
						widget: '#snManager',
						event: 'recieveProfile',
						callback: 'handleOauthMessage'
					},
					
				},
				handleDom: {
					// submit: {
					// 	target: '#send-button',
					// 	event: 'click',
					// 	callback: 'submit' 
					// },
					checkForEmpry: {
						target: '.not-empty',
						event: 'blur',
						callback: fox.bind(function (elem) {
							if (elem.name === 'email') {
								return;
							}

							if (!fox.trim(elem.value).length) {
								this.showError(elem.name, _.getTranslation('fieldIsRequired'));
							} else {
								this.showSuccess(elem.name);
							}
						}, this)
					},
					inputFocus: {
						target: '.fields2send',
						event: 'focus',
						callback: 'handleEvents'
					},
					inputBlur: {
						target: '.fields2send',
						event: 'blur',
						callback: 'handleEvents'
					},
					formSubmit: {
						target: '#reg-form',
						event: 'submit',
						callback: 'submit'
					}
				},
				'hooks.onAddedToDom': 'handleLogin'
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			var acode = fox.Navigator.get(2);
			if (!fox.isEmpty(acode)) {
				fox.Consent.checkCookie('acode')
					.then(function () {
						fox.cookie.set('acode', acode, 3600*24*90*1000);
					});
			}
		},

		rendering: function() {
			this.callParent('rendering', arguments);
			this.fields = fox.dom.select('.fields2send', this.fragment);
			this.renderRecaptchaContainers();
		},

		handleLogin: function() {
			this.recaptcha = this.rwom1('#recaptcha');

			if (this.recaptcha.isNeed()) {
				this.recaptcha.load();
			}

			if (!fox.isEmpty(fox.cookie.get('snProfile'))) { // from login
				var snProfile = JSON.parse(fox.cookie.get('snProfile'));
				this.handleOauthMessage(snProfile, {'appName': snProfile.alias});
				fox.cookie.remove('snProfile');
			}
		},

		submit: function (elt, alias, w, e) {
			e.preventDefault();
			if (this.dataIsValid() && !this.buttonPressed) {
				this.register(this.data);
			}
		},

		checkEmail: function () {
			var input = fox.dom.sel1('[name=email]', this.fields);
			var value = fox.trim(input.val());
			if (!value.length || !!value.match(/\s/g) || !value.match(/^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/g)) {

				this.showError('email', _.getTranslation('enterValidEmail'));
				this.isEmailValid = false;
				return fox.RSVP.Promise.resolve(false);
			}

			var api = this.rwom1('#checkEmailApi');

			var data = {
				email: value,
				xsid: input.attr('data-xsid')
			};

			return api.psend(data, false).then(function(data) {
				data = data.params;

				if (data.answer.response.success.errors.length === 0) {
					this.hideError('email');
					this.showSuccess('email');
					this.isEmailValid = true;
				} else {
					this.showError('email', data.answer.response.success.errors);
					this.isEmailValid = false;
				}
				return this.isEmailValid;
			}.bind(this)).catch(function (resp) {
				this.showError('email', resp.params.answer.reason);
				return fox.RSVP.Promise.resolve(false);
			}.bind(this));

		},

		register: function (data) {
			this.checkEmail().then(function (valid) {
				if (!valid) {
					return;
				}

				this.togglePreloader();
				return this.getUDID().then(function(_udid) {
					var requestData = fox.merge({udid: _udid}, this.data);
					var recaptcha = this.recaptcha || this.rwom1('#recaptcha');

					if (!recaptcha || !recaptcha.isNeed()) {
						return this.rwom1('#registerApi').send(requestData);
					}

					return recaptcha.getToken('registration').then(function(token) {
						if (recaptcha.captchaVariant === 'invisible') {
							requestData['g-recaptcha-invisible-response'] = token;
							return this.rwom1('#registerApi').send(requestData);
						}

						if (!token) {
							this.showError('captcha', 'Please complete the captcha below to proceed.');
							this.togglePreloader();
							return;
						}

						requestData['g-recaptcha-response'] = token;
						return this.rwom1('#registerApi').send(requestData);
					}.bind(this));
				}.bind(this));
			}.bind(this));
		},

		renderRecaptchaContainers: function () {
			var form = fox.dom.selectFirst('#reg-form', this.fragment);

			if (!form || fox.dom.selectFirst('#ReCaptchaFoxInVisible', form)) {
				return;
			}

			var container = document.createElement('div');

			container.innerHTML = '<div id="ReCaptchaFoxInVisible" style="position:absolute;visibility:hidden;"></div><div id="ReCaptchaFox" style="display:none;margin:10px 0;"></div>';
			form.insertBefore(container, fox.dom.selectFirst('.submit-container', form));
		},

		showErrorPopup: function () {
			this.rwom1('#errorPopup').show();
		},

		showRecaptchaOnError: function () {
			if (this.recaptcha && this.recaptcha.isNeed()) {
				this.recaptcha.load('onError');
			}
		},

		signIn: function (response) {
			if (!response.answer.status) {
				return;
			}
			fox.Navigator.update({0:'registration', 1:'step2'}, true);
			window.location.reload(true);
		},

		dataIsValid: function () {
			var result = true;

			fox.each(this.fields, function(field) {

				var value = field.type == 'checkbox' ? Number(field.checked) : fox.trim(field.value);

				if (field.name === 'consent_tos' && !field.checked) {
					result = false;
					this.showError(field.name, _.getTranslation('errorAgreeOperatorAgreement'));
					return;
				}

				if (field.classList.contains('not-empty') && !value) {
					result = false;
					this.showError(field.name, _.getTranslation('fieldIsRequired'));

					return;
				}

				this.data[field.name] = value;
				this.showSuccess(field.name);

			}, this);

			if (!this.isEmailValid) {
				result = false;
				this.showError('email', _.getTranslation('enterValidEmail'));
			}
			return result;
		},

		showError: function (name, msg) {
			var field;
			var parent;
			var messageBlock;
			msg = msg || '&nbsp;';

			fox.each(this.fields, function (elem) {
				if (elem.name === name) {
					field = elem;
					throw fox.break;
				}
			}, this);

			if (field) {
				parent = field.parentNode;
				fox.dom.addClass('error', parent);
				fox.dom.removeClass('success', parent);
				messageBlock = fox.dom.selectFirst('.message', parent);

				if (fox.dom.isDomNode(messageBlock)) {
					messageBlock.innerHTML = msg;
				}
			}
		},

		hideError: function (name) {
			var field;
			var parent;

			fox.each(this.fields, function (elem) {
				if (elem.name === name) {
					field = elem;
					throw fox.break;
				}
			}, this);

			if (field) {
				parent = field.parentNode;
				fox.dom.removeClass('error', parent);
				fox.dom.selectFirst('.message', parent).innerHTML = '';
			} 
		},

		showSuccess: function (name) {
			var field;

			fox.each(this.fields, function (elem) {
				if (elem.name === name) {
					field = elem;
					throw fox.break;
				}
			}, this);
			

			if (field) {
				fox.dom.removeClass('error', field.parentNode);
				fox.dom.addClass('success', field.parentNode);
			} 
		},

		togglePreloader: function () {
			var button = fox.dom.selectFirst('#send-button span', this.element);
			if (!this.buttonPressed) {
				this.buttonPressed = true;
				fox.dom.addClass('spin', button);
				return;
			}
			this.buttonPressed = false;
			fox.dom.removeClass('spin', button);
		},

		handleEvents: function (el, alias, widget, e) {
			var parent = fox.dom.wrap(el.parentNode);

			if (e.type === 'focus') {
				parent.removeClass('error').removeClass('success').addClass('focus');
				fox.dom.removeClass('');
				return;
			} else if (e.type === 'blur' && el.name === 'email') {
				this.checkEmail();
			}

			parent.removeClass('focus');

		},

		renderNetworksTemplate: function () {
			var w = this.wom1('#snManager');
			var collection = w.getDataLayer().getCollection();
			var data = {};

			if (!collection) {
				return;
			}

			fox.each(collection, function (obj) {
				
				if (obj.alias === 'twitter') {
					data.twitterUrl = obj.requestUrl;
					return;
				}

				data.facebookUrl = obj.requestUrl;
			});

			w.setTemplateOptions(data).render();
		},

		handleOauthMessage: function (data, w, e) {
			if (!data || !data.userInfo) {
				return;
			}

			this.fillFields(data.userInfo);

			if (w.appName === 'twitter') {
				this.data['imid[twitter]'] = data.userInfo.screen;
				return;
			}

			this.register(data.userInfo);
		},

		fillFields: function (data) {
			fox.each(data, function (val, name) {
				fox.each(this.fields, function(field) {
					if (field.name === name) {
						field.value = val;
					}
				}, this);
			}, this);

			this.dataIsValid();
		},

		getUDID: function() {
            return EXO_UDID.getShortUid();
		},

	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/promo/registration.js
// module id = 39
// module chunks = 2